<template>
    <v-container fluid v-if="mezzo">
        <v-btn icon variant="text" class="mb-2" @click="tornaIndietro">
            <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <v-row>
            <v-col cols="12" md="8">
                <v-card>
                    <v-card-title class="d-flex align-center">
                        {{ mezzo.nome }}
                        <v-chip class="ml-3" size="small" :color="coloreStato(mezzo.stato)" variant="flat">
                            {{ etichettaStato(mezzo.stato) }}
                        </v-chip>
                        <v-spacer />
                        <v-btn v-if="puoScrivere" size="small" variant="text" prepend-icon="mdi-pencil"
                            @click="dialogModifica = true">
                            Modifica
                        </v-btn>
                    </v-card-title>
                    <v-card-subtitle>{{ mezzo.categoria }}</v-card-subtitle>
                    <v-card-text>
                        <v-row>
                            <v-col cols="6"><strong>Codice:</strong> {{ mezzo.codice || '—' }}</v-col>
                            <v-col cols="6"><strong>Targa:</strong> {{ mezzo.targa || '—' }}</v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="6"><strong>Marca:</strong> {{ mezzo.marca || '—' }}</v-col>
                            <v-col cols="6"><strong>Modello:</strong> {{ mezzo.modello || '—' }}</v-col>
                        </v-row>
                        <div class="mt-2" v-if="mezzo.descrizione"><strong>Descrizione:</strong>
                            {{ mezzo.descrizione }}</div>
                        <div class="mt-2" v-if="mezzo.note"><strong>Note:</strong> {{ mezzo.note }}</div>
                    </v-card-text>
                </v-card>

                <v-card class="mt-4">
                    <v-card-title class="d-flex align-center">
                        Documenti
                        <v-spacer />
                        <v-file-input v-model="fileDocumento" label="Carica documento (PDF)" accept="application/pdf"
                            density="compact" hide-details style="max-width: 260px" prepend-icon="mdi-upload"
                            @update:model-value="caricaDocumento" />
                    </v-card-title>
                    <v-card-text>
                        <v-list v-if="mezzo.allegati && mezzo.allegati.length > 0">
                            <v-list-item v-for="a in mezzo.allegati" :key="a.id" :title="a.nomeOriginale"
                                prepend-icon="mdi-file-pdf-box" />
                        </v-list>
                        <span v-else class="text-medium-emphasis">Nessun documento caricato.</span>
                    </v-card-text>
                </v-card>

                <v-card class="mt-4">
                    <v-card-title class="d-flex align-center">
                        Scadenze
                        <v-spacer />
                        <v-btn v-if="puoScrivere" size="small" color="primary" prepend-icon="mdi-plus"
                            @click="dialogNuova = true">
                            Nuova
                        </v-btn>
                    </v-card-title>
                    <v-list>
                        <v-list-item v-for="s in scadenze" :key="s.id" :title="s.tipoScadenzaMezzoNome"
                            :subtitle="descrizioneRiga(s)">
                            <template #prepend>
                                <v-chip size="small" :color="coloreRiga(s)" variant="flat">
                                    {{ etichettaRiga(s) }}
                                </v-chip>
                            </template>
                            <template #append v-if="puoScrivere">
                                <!-- Niente "Inizia": una scadenza mezzo non ha wizard di fermo. -->
                                <v-btn v-if="s.stato === 'Pianificata'" size="small" variant="text" color="primary"
                                    @click="apriCompletamento(s.id)">
                                    Completa
                                </v-btn>
                                <v-btn v-if="s.stato === 'Pianificata'" icon variant="text" size="small"
                                    title="Modifica data/note" @click="apriRiprogramma(s)">
                                    <v-icon size="small">mdi-pencil</v-icon>
                                </v-btn>
                                <v-btn v-if="s.stato === 'Completata'" icon variant="text" size="small"
                                    title="Modifica note/data di esecuzione" @click="apriModificaCompletamento(s)">
                                    <v-icon size="small">mdi-pencil</v-icon>
                                </v-btn>
                                <v-btn v-if="s.stato === 'Completata'" icon variant="text" size="small"
                                    title="Annulla completamento (confermata per errore)"
                                    @click="chiediRiapertura(s)">
                                    <v-icon size="small">mdi-undo</v-icon>
                                </v-btn>
                                <v-btn icon variant="text" size="small" title="Duplica" @click="duplicaScadenza(s)">
                                    <v-icon size="small">mdi-content-copy</v-icon>
                                </v-btn>
                                <v-btn icon variant="text" size="small" color="error" @click="chiediEliminazione(s)">
                                    <v-icon size="small">mdi-delete</v-icon>
                                </v-btn>
                            </template>
                        </v-list-item>
                        <v-list-item v-if="scadenze.length === 0">
                            <span class="text-medium-emphasis">Nessuna scadenza registrata.</span>
                        </v-list-item>
                    </v-list>
                </v-card>

                <v-card class="mt-4">
                    <v-card-title class="d-flex align-center">
                        Cambio gomme
                        <v-spacer />
                        <v-btn v-if="puoScrivere" size="small" color="primary" prepend-icon="mdi-plus"
                            @click="apriCambioGomme(null)">
                            Registra cambio
                        </v-btn>
                    </v-card-title>
                    <v-list>
                        <v-list-item v-for="g in cambiGomme" :key="g.id"
                            :title="`${formatData(g.data)} — gomme ${etichettaStagione(g.stagione)}`"
                            :subtitle="descrizioneGomme(g)">
                            <template #prepend>
                                <v-icon :color="iconaStagione(g.stagione).colore" class="mr-3">
                                    {{ iconaStagione(g.stagione).icona }}
                                </v-icon>
                            </template>
                            <template #append v-if="puoScrivere">
                                <v-btn icon variant="text" size="small" title="Modifica" @click="apriCambioGomme(g)">
                                    <v-icon size="small">mdi-pencil</v-icon>
                                </v-btn>
                                <v-btn icon variant="text" size="small" color="error" title="Elimina"
                                    @click="chiediEliminazioneGomme(g)">
                                    <v-icon size="small">mdi-delete</v-icon>
                                </v-btn>
                            </template>
                        </v-list-item>
                        <v-list-item v-if="cambiGomme.length === 0">
                            <span class="text-medium-emphasis">Nessun cambio gomme registrato.</span>
                        </v-list-item>
                    </v-list>
                </v-card>

                <v-card class="mt-4">
                    <v-card-title class="d-flex align-center">
                        Annotazioni
                        <v-spacer />
                        <v-btn v-if="puoScrivere" size="small" color="primary" prepend-icon="mdi-plus"
                            @click="apriAnnotazione(null)">
                            Aggiungi
                        </v-btn>
                    </v-card-title>
                    <v-list lines="three">
                        <v-list-item v-for="a in annotazioni" :key="a.id"
                            :title="a.titolo ? `${formatData(a.data)} — ${a.titolo}` : formatData(a.data)">
                            <template #subtitle>
                                <span class="annotazione-testo">{{ a.testo }}</span>
                            </template>
                            <template #prepend>
                                <v-icon class="mr-3">mdi-note-text</v-icon>
                            </template>
                            <template #append v-if="puoScrivere">
                                <v-btn icon variant="text" size="small" title="Modifica" @click="apriAnnotazione(a)">
                                    <v-icon size="small">mdi-pencil</v-icon>
                                </v-btn>
                                <v-btn icon variant="text" size="small" color="error" title="Elimina"
                                    @click="chiediEliminazioneAnnotazione(a)">
                                    <v-icon size="small">mdi-delete</v-icon>
                                </v-btn>
                            </template>
                        </v-list-item>
                        <v-list-item v-if="annotazioni.length === 0">
                            <span class="text-medium-emphasis">Nessuna annotazione.</span>
                        </v-list-item>
                    </v-list>
                </v-card>

                <v-card class="mt-4">
                    <v-card-title class="d-flex align-center">
                        Dispositivi di sicurezza
                        <v-spacer />
                        <v-btn v-if="puoScrivere" size="small" color="primary" prepend-icon="mdi-plus"
                            @click="dialogNuovoDispositivo = true">
                            Nuovo
                        </v-btn>
                    </v-card-title>
                    <v-list>
                        <v-list-item v-for="d in dispositiviSicurezza" :key="d.id" :title="d.nome"
                            :subtitle="d.tipoDispositivoSicurezzaNome" :to="`/sicurezza/${d.id}`">
                            <template #append>
                                <v-chip v-if="d.contenutiScaduti > 0" size="small" color="error" variant="flat">
                                    {{ d.contenutiScaduti }} scadut{{ d.contenutiScaduti === 1 ? 'o' : 'i' }}
                                </v-chip>
                            </template>
                        </v-list-item>
                        <v-list-item v-if="dispositiviSicurezza.length === 0">
                            <span class="text-medium-emphasis">Nessun dispositivo di sicurezza collegato.</span>
                        </v-list-item>
                    </v-list>
                </v-card>
            </v-col>

            <v-col cols="12" md="4">
                <v-card>
                    <v-card-title>QR code</v-card-title>
                    <v-card-text class="text-center">
                        <div id="area-stampa-qr">
                            <canvas ref="qrCanvas"></canvas>
                            <div class="mt-2 text-caption text-medium-emphasis">Se non riesci a scansionare,
                                copia il link:</div>
                            <div class="text-body-2">{{ urlPubblico }}</div>
                        </div>
                        <v-btn class="mt-3" variant="outlined" prepend-icon="mdi-printer" @click="stampa">
                            Stampa
                        </v-btn>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <dialog-mezzo v-model="dialogModifica" :mezzo="mezzo" @salvato="carica" />

        <dialog-nuova-scadenza-mezzo v-model="dialogNuova" :mezzo-id="id" @salvato="ricaricaScadenze" />

        <dialog-completa-scadenza-mezzo v-model="dialogCompletamento" :scadenza-mezzo-id="scadenzaSelezionataId"
            :mezzo-id="id" @completata="onScadenzaAggiornata" />

        <dialog-dispositivo-sicurezza v-model="dialogNuovoDispositivo" :mezzo-fisso="id"
            @salvato="ricaricaDispositiviSicurezza" />

        <dialog-cambio-gomme v-model="dialogCambioGomme" :mezzo-id="id" :cambio="cambioSelezionato" />

        <dialog-modifica-completamento v-if="scadenzaCompletamento" v-model="dialogModificaCompletamento"
            titolo="Modifica scadenza completata" :sottotitolo="scadenzaCompletamento.tipoScadenzaMezzoNome"
            avviso-data="Se la prossima scadenza è stata generata da questo completamento (e non è ricorrente), verrà ricalcolata dalla nuova data."
            :data-esecuzione="scadenzaCompletamento.dataCompletamento"
            :note="scadenzaCompletamento.noteCompletamento" :azione="salvaCompletamento" />

        <dialog-annotazione-mezzo v-model="dialogAnnotazione" :mezzo-id="id" :annotazione="annotazioneSelezionata" />

        <dialog-riprogramma v-if="scadenzaRiprogramma" v-model="dialogRiprogramma" titolo="Modifica scadenza"
            :sottotitolo="scadenzaRiprogramma.tipoScadenzaMezzoNome"
            :avviso-data="scadenzaRiprogramma.ricorrente ? 'Scadenza ricorrente: spostando la data si spostano anche le occorrenze successive della serie.' : ''"
            :data-prevista="scadenzaRiprogramma.dataPrevista" :descrizione="scadenzaRiprogramma.descrizione"
            :azione="salvaRiprogramma" />

        <v-dialog v-model="dialogRiapri" max-width="460" @keydown.esc="dialogRiapri = false">
            <v-card>
                <v-card-title>Annullare il completamento?</v-card-title>
                <v-card-text>
                    La scadenza torna "da fare" con la sua data originale, le note del completamento vengono
                    rimosse e la scadenza successiva generata dal completamento viene eliminata.
                    <v-alert v-if="erroreRiapertura" type="error" variant="tonal" density="comfortable"
                        class="rounded-lg mt-3">
                        {{ erroreRiapertura }}
                    </v-alert>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn variant="text" @click="dialogRiapri = false">Annulla</v-btn>
                    <v-btn color="primary" @click="confermaRiapertura">Riapri scadenza</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogEliminaAnnotazione" max-width="420"
            @keydown.esc="dialogEliminaAnnotazione = false">
            <v-card>
                <v-card-title>Confermi l'eliminazione?</v-card-title>
                <v-card-text>L'annotazione verrà rimossa.</v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn variant="text" @click="dialogEliminaAnnotazione = false">Annulla</v-btn>
                    <v-btn color="error" @click="confermaEliminazioneAnnotazione">Elimina</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogEliminaGomme" max-width="420" @keydown.esc="dialogEliminaGomme = false">
            <v-card>
                <v-card-title>Confermi l'eliminazione?</v-card-title>
                <v-card-text>Il cambio gomme verrà rimosso dal registro.</v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn variant="text" @click="dialogEliminaGomme = false">Annulla</v-btn>
                    <v-btn color="error" @click="confermaEliminazioneGomme">Elimina</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogElimina" max-width="420">
            <v-card>
                <v-card-title>Confermi l'eliminazione?</v-card-title>
                <v-card-text>La scadenza verrà rimossa.</v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn variant="text" @click="dialogElimina = false">Annulla</v-btn>
                    <v-btn color="error" @click="confermaEliminazione">Elimina</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
    <v-container v-else>
        <v-progress-circular indeterminate color="primary" />
    </v-container>
</template>

<script>
import QRCode from "qrcode";
import { upload_allegato_mezzo } from "@/api/api.allegati.js";
import DialogNuovaScadenzaMezzo from "@/components/scadenzeMezzo/DialogNuovaScadenzaMezzo.vue";
import DialogCompletaScadenzaMezzo from "@/components/scadenzeMezzo/DialogCompletaScadenzaMezzo.vue";
import DialogMezzo from "@/components/mezzi/DialogMezzo.vue";
import DialogDispositivoSicurezza from "@/components/sicurezza/DialogDispositivoSicurezza.vue";
import DialogCambioGomme from "@/components/mezzi/DialogCambioGomme.vue";
import DialogAnnotazioneMezzo from "@/components/mezzi/DialogAnnotazioneMezzo.vue";
import DialogModificaCompletamento from "@/components/common/DialogModificaCompletamento.vue";
import DialogRiprogramma from "@/components/common/DialogRiprogramma.vue";
import { coloreStato, etichettaStato } from "@/constants/statoMezzo.js";
import { coloreRiga, etichettaRiga } from "@/constants/statoScadenzaMezzo.js";

export default {
    name: "MezzoDettaglioPage",

    components: {
        DialogNuovaScadenzaMezzo,
        DialogCompletaScadenzaMezzo,
        DialogMezzo,
        DialogDispositivoSicurezza,
        DialogCambioGomme,
        DialogAnnotazioneMezzo,
        DialogModificaCompletamento,
        DialogRiprogramma,
    },

    props: {
        id: { type: [String, Number], required: true },
    },

    data() {
        return {
            fileDocumento: null,
            dialogNuova: false,
            dialogCompletamento: false,
            dialogModifica: false,
            scadenzaSelezionataId: null,
            dialogElimina: false,
            scadenzaDaEliminare: null,
            dialogNuovoDispositivo: false,
            dialogCambioGomme: false,
            cambioSelezionato: null,
            dialogEliminaGomme: false,
            cambioDaEliminare: null,
            dialogModificaCompletamento: false,
            scadenzaCompletamento: null,
            dialogAnnotazione: false,
            annotazioneSelezionata: null,
            dialogEliminaAnnotazione: false,
            annotazioneDaEliminare: null,
            dialogRiprogramma: false,
            scadenzaRiprogramma: null,
            dialogRiapri: false,
            scadenzaDaRiaprire: null,
            erroreRiapertura: null,
        };
    },

    computed: {
        mezzo() {
            return this.$store.getters["mezzi/corrente"];
        },
        scadenze() {
            return this.$store.getters["scadenzeMezzo/lista"];
        },
        dispositiviSicurezza() {
            return this.$store.getters["dispositiviSicurezza/lista"];
        },
        cambiGomme() {
            return this.$store.getters["cambiGomme/lista"];
        },
        annotazioni() {
            return this.$store.getters["annotazioniMezzo/lista"];
        },
        ruolo() {
            return this.$store.getters["user/getRole"];
        },
        puoScrivere() {
            return this.ruolo === "SuperAdmin" || this.ruolo === "Admin" || this.ruolo === "Operatore";
        },
        urlPubblico() {
            return `${window.location.origin}/mezzi/${this.id}`;
        },
    },

    watch: {
        id: {
            immediate: true,
            handler() {
                this.carica();
            },
        },
    },

    methods: {
        tornaIndietro() {
            this.$router.push("/mezzi");
        },

        async carica() {
            try {
                await this.$store.dispatch("mezzi/caricaDettaglio", this.id);
                await this.ricaricaScadenze();
                await this.ricaricaDispositiviSicurezza();
                await this.$store.dispatch("cambiGomme/carica", { mezzoId: this.id });
                await this.$store.dispatch("annotazioniMezzo/carica", { mezzoId: this.id });
                await this.$nextTick();
                this.generaQr();
            } catch (error) {
                console.log(error);
            }
        },

        ricaricaScadenze() {
            return this.$store.dispatch("scadenzeMezzo/carica", { mezzoId: this.id });
        },

        ricaricaDispositiviSicurezza() {
            return this.$store.dispatch("dispositiviSicurezza/carica", { mezzoId: this.id });
        },

        generaQr() {
            if (!this.$refs.qrCanvas) return;
            QRCode.toCanvas(this.$refs.qrCanvas, this.urlPubblico, { width: 220 }, (err) => {
                if (err) console.log(err);
            });
        },

        stampa() {
            window.print();
        },

        async caricaDocumento(file) {
            if (!file) return;
            try {
                await upload_allegato_mezzo(this.id, file);
                await this.$store.dispatch("mezzi/caricaDettaglio", this.id);
                this.fileDocumento = null;
            } catch (error) {
                console.log(error);
            }
        },

        apriCompletamento(scadenzaId) {
            this.scadenzaSelezionataId = scadenzaId;
            this.dialogCompletamento = true;
        },

        async onScadenzaAggiornata() {
            await this.ricaricaScadenze();
            await this.$store.dispatch("mezzi/caricaDettaglio", this.id);
        },

        // La lista non porta le note: si carica il dettaglio prima di aprire il dialog.
        async apriModificaCompletamento(s) {
            try {
                await this.$store.dispatch("scadenzeMezzo/caricaDettaglio", s.id);
                this.scadenzaCompletamento = this.$store.getters["scadenzeMezzo/corrente"];
                this.$nextTick(() => {
                    this.dialogModificaCompletamento = true;
                });
            } catch (error) {
                console.log(error);
            }
        },

        async salvaCompletamento({ dataEsecuzione, note }) {
            await this.$store.dispatch("scadenzeMezzo/modificaCompletamento", {
                id: this.scadenzaCompletamento.id,
                dati: { dataEsecuzione, note },
                mezzoId: this.id,
            });
        },

        // La lista non porta descrizione/ricorrente: si carica il dettaglio prima di aprire il dialog.
        async apriRiprogramma(s) {
            try {
                await this.$store.dispatch("scadenzeMezzo/caricaDettaglio", s.id);
                this.scadenzaRiprogramma = this.$store.getters["scadenzeMezzo/corrente"];
                this.$nextTick(() => {
                    this.dialogRiprogramma = true;
                });
            } catch (error) {
                console.log(error);
            }
        },

        async salvaRiprogramma({ dataPrevista, descrizione }) {
            await this.$store.dispatch("scadenzeMezzo/riprogramma", {
                id: this.scadenzaRiprogramma.id,
                dati: {
                    dataPrevista,
                    descrizione,
                    // Il flag non si cambia da qui: si rimanda quello esistente.
                    ricorrente: this.scadenzaRiprogramma.ricorrente,
                },
                mezzoId: this.id,
            });
        },

        chiediRiapertura(s) {
            this.scadenzaDaRiaprire = s;
            this.erroreRiapertura = null;
            this.dialogRiapri = true;
        },

        async confermaRiapertura() {
            try {
                await this.$store.dispatch("scadenzeMezzo/riapri", {
                    id: this.scadenzaDaRiaprire.id,
                    mezzoId: this.id,
                });
                await this.$store.dispatch("mezzi/caricaDettaglio", this.id);
                this.dialogRiapri = false;
            } catch (error) {
                console.log(error);
                this.erroreRiapertura = (error.response && error.response.data && error.response.data.message)
                    || "Non è stato possibile riaprire la scadenza.";
            }
        },

        apriAnnotazione(annotazione) {
            this.annotazioneSelezionata = annotazione;
            this.dialogAnnotazione = true;
        },

        chiediEliminazioneAnnotazione(annotazione) {
            this.annotazioneDaEliminare = annotazione;
            this.dialogEliminaAnnotazione = true;
        },

        async confermaEliminazioneAnnotazione() {
            try {
                await this.$store.dispatch("annotazioniMezzo/elimina", {
                    id: this.annotazioneDaEliminare.id,
                    mezzoId: this.id,
                });
            } catch (error) {
                console.log(error);
            }
            this.dialogEliminaAnnotazione = false;
        },

        etichettaStagione(stagione) {
            return { Invernali: "invernali", Estive: "estive", QuattroStagioni: "4 stagioni" }[stagione] || stagione;
        },

        iconaStagione(stagione) {
            return {
                Invernali: { icona: "mdi-snowflake", colore: "info" },
                Estive: { icona: "mdi-white-balance-sunny", colore: "warning" },
                QuattroStagioni: { icona: "mdi-autorenew", colore: "success" },
            }[stagione] || { icona: "mdi-help-circle-outline", colore: "grey" };
        },

        apriCambioGomme(cambio) {
            this.cambioSelezionato = cambio;
            this.dialogCambioGomme = true;
        },

        chiediEliminazioneGomme(cambio) {
            this.cambioDaEliminare = cambio;
            this.dialogEliminaGomme = true;
        },

        async confermaEliminazioneGomme() {
            try {
                await this.$store.dispatch("cambiGomme/elimina", { id: this.cambioDaEliminare.id, mezzoId: this.id });
            } catch (error) {
                console.log(error);
            }
            this.dialogEliminaGomme = false;
        },

        formatData(data) {
            return data ? new Date(data).toLocaleDateString("it-IT") : "—";
        },

        descrizioneGomme(g) {
            const parti = [];
            if (g.eseguitoDa) parti.push(`eseguito da ${g.eseguitoDa}`);
            parti.push(g.nuoveAcquistate ? "gomme nuove acquistate" : "gomme già in uso");
            if (g.km != null) parti.push(`${g.km.toLocaleString("it-IT")} km`);
            if (g.note) parti.push(g.note);
            return parti.join(" · ");
        },

        async duplicaScadenza(s) {
            try {
                await this.$store.dispatch("scadenzeMezzo/duplica", { id: s.id, mezzoId: this.id });
            } catch (error) {
                console.log(error);
            }
        },

        chiediEliminazione(s) {
            this.scadenzaDaEliminare = s;
            this.dialogElimina = true;
        },

        async confermaEliminazione() {
            try {
                await this.$store.dispatch("scadenzeMezzo/elimina", {
                    id: this.scadenzaDaEliminare.id,
                    mezzoId: this.id,
                });
                await this.$store.dispatch("mezzi/caricaDettaglio", this.id);
            } catch (error) {
                console.log(error);
            }
            this.dialogElimina = false;
        },

        coloreStato,
        etichettaStato,
        coloreRiga,
        etichettaRiga,

        descrizioneRiga(s) {
            const data = s.stato === "Completata" ? s.dataCompletamento : s.dataPrevista;
            return data ? new Date(data).toLocaleDateString("it-IT") : "";
        },
    },
};
</script>

<style scoped>
.annotazione-testo {
    white-space: pre-line;
    display: block;
}
</style>
